/**
 * Filters out undefined and null values from an object before sending to API
 * @param obj The object to clean
 * @returns A new object with undefined and null values removed
 */
export const cleanPayload = <T extends object>(obj: T): Partial<T> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined && v !== null)
  ) as Partial<T>
}
